import script from "./CMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CMessage.vue?vue&type=script&lang=ts&setup=true"

import "./CMessage.vue?vue&type=style&index=0&id=2577d53e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2577d53e"]])

export default __exports__